import { render } from "./LatestProjects.vue?vue&type=template&id=3190be26&scoped=true"
import script from "./LatestProjects.vue?vue&type=script&lang=js"
export * from "./LatestProjects.vue?vue&type=script&lang=js"

import "./LatestProjects.vue?vue&type=style&index=0&id=3190be26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3190be26"]])

export default __exports__